import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

/**
 * Servicio para la gestión de personal de cadena (group_admin / gerentes).
 * Todo vía Cloud Functions (Admin SDK): autoriza por el claim y no depende de
 * reglas/propagación en el cliente.
 */
export const orgTeamService = {
  /** Devuelve gerentes + invitaciones pendientes de la cadena. */
  async getTeam() {
    const fn = httpsCallable(functions, 'restaurants-endpoints-getOrgTeam');
    const res = await fn();
    return res.data; // { staff, invitations }
  },

  /** Invita a un gerente (email + scope: 'ALL' o array de restaurantId). */
  async sendInvitation({ email, scope }) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-sendOrgInvitation');
    const res = await fn({ email, scope });
    return res.data;
  },

  /** Gestiona un gerente o invitación: update | suspend | reactivate | remove | cancelInvitation. */
  async manageMember(payload) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-manageOrgMember');
    const res = await fn(payload);
    return res.data;
  },

  /** Verifica un token de invitación de cadena (público, para la página de aceptación). */
  async verifyInvitationToken(token) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-verifyOrgInvitationToken');
    const res = await fn({ token });
    return res.data;
  },

  /** Acepta una invitación de cadena. */
  async acceptInvitation(token, name, password) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-acceptOrgInvitation');
    const res = await fn({ token, name, password });
    return res.data;
  },
};
